import AtAGlance from "pages/PanelPage/components/selectedAssessment/assessmentResults/AtAGlance/AtAGlance";

export default AtAGlance;
